<template>
  <div class='SelectFrenteLoja'>
    <div class="text">
      {{ Empresa.frenteloja ? 'Ativo' : 'Desativado' }}
    </div>
    <div class="btn">
      <button @click="_UpdateFrenteLoja({ frenteloja: !Empresa.frenteloja })">{{ Empresa.frenteloja ? 'Desativar' : 'Ativar' }}</button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'SelectFrenteLoja',
  computed: {
    ...mapGetters(['Empresa'])
  },
  methods: {
    ...mapActions(['_UpdateFrenteLoja'])
  }
}
</script>

<style scoped>
.SelectFrenteLoja {
  display: flex;
  justify-content: center;
  align-items: center;
}

.text {
  text-align: left;
  width: 80%;
  padding: 2%;
  border: thin solid #CCCCCC;
  cursor: pointer;
  border-radius: 5px;
}

.btn {
  width: 20%;
}

button {
  color: #FFFFFF;
  padding: 8%;
  background-color: #000000;
  border: 0;
  border-radius: 5px;
  cursor: pointer;
}

</style>
